import { List, Map } from 'immutable'
import { updateObject } from 'utils/updateObject'
import setFilters from 'store/reducer-utils/setFilters'

const initialState = {
  loading: true,
  loadFailed: false,
  data: [],
  pagination: {
    offset: 0,
    limit: 50,
    total: 0,
  },
  filters: null,
}

const setData = (state, { payload: { data, pagination } }) =>
  updateObject(state, {
    loadFailed: false,
    loading: false,
    data,
    pagination: {
      ...state.pagination,
      ...pagination,
    },
  })

const loadFailed = (state) =>
  updateObject(state, { loadFailed: false, loading: false, data: [] })

const loadCanceled = (state) =>
  updateObject(state, { loadFailed: false, loading: true, data: [] })

const removeRequest = (state, { payload }) =>
  updateObject(state, {
    data: [...state.data].filter((client) => client.id !== payload.id),
  })

const requestUpdate = (state, { payload }) => {
  let data = List(state.data)
  const index = data.findIndex((request) => request.id === payload.id)
  data = data.set(index, Map(data.get(index)).merge(payload.update))
  return updateObject(state, { data: data.toJS() })
}

const clientsSetFilter = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const dropData = (state) =>
  updateObject(state, {
    data: [],
    loading: true,
    loadFailed: false,
    pagination: { offset: 0, limit: 50, total: 0 },
  })

const toggleLoading = (state, { payload }) =>
  updateObject(state, { loading: payload.loading })

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AGENCY/REQUESTS_SET_DATA':
      return setData(state, action)
    case 'AGENCY/REQUESTS_FETCH_FAILED':
      return loadFailed(state, action)
    case 'AGENCY/REQUESTS_FETCH_CANCELED':
      return loadCanceled(state, action)
    case 'AGENCY/REQUESTS_LIST_REMOVE_ITEM':
      return removeRequest(state, action)
    case 'AGENCY/REQUEST_UPDATE':
      return requestUpdate(state, action)
    case 'AGENCY/REQUESTS_SET_FILTER':
      return clientsSetFilter(state, action)
    case 'AGENCY/REQUESTS_TOGGLE_LOADING':
      return toggleLoading(state, action)
    case 'AGENCY/REQUESTS_DROP_DATA':
      return dropData(state, action)
    default:
      return state
  }
}

export default reducer
